var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-title"},[_c('h1',[_vm._v(_vm._s(_vm.infoName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }